import { useContext, useEffect, useRef, useState } from 'react';
import TickMark from '../../../../Assets/Modals/TickMark.svg';
import showhide from "../../../../Assets/ShowHide.svg";
import DotsVertical from '../../../../Assets/OrderManagement/DotsVertical.svg';
import { useNavigate } from 'react-router-dom';
import { useOutsideClickForTwoRef } from '../../../../Hooks/useOutsideClickForTwoRef';
import KebabMenu from './KebabMenu';
import { useDispatch, useSelector } from 'react-redux';
import { closeProductKebabMenu, openProductKebabMenu, setModal, setSelectedProduct, updateInventoryProducts } from '../../../../Features/inventoryManagementSlice';
import { accessProductVisibility, cachedDataPublish, updateProduct } from '../../../../lib/utils/apiCalls';
import { showToast } from '../../../../Components/Toaster/Toaster';
import { InventoryManagementContext } from '../../../../Context/InventoryManagementContext';

import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import LoadingTransparent from '../../../../Components/Loading/LoadingTransparent';

Autoplay.globalOptions = {
    delay: 8000
}

function ProductBar({ product, status, isSelected }) {
    const getStatusColor = (prodStatus) => {
        if(!prodStatus) {
            prodStatus = status;
        }
        switch (prodStatus) {
            case 'Active':
                return 'text-[#065F46] bg-[#D1FAE5]';
            case 'Draft':
                return 'text-[#92400E] bg-[#FEF3C7]';
            case 'Out of Stock':
                return 'text-[#991B1B] bg-[#FEE2E2]';
            case 'InActive':
                return 'text-[#666666] bg-[#EAEAEA]';
            case 'Inactive':
                return 'text-[#666666] bg-[#EAEAEA]';
            default:
                return '';
        }
    };

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [emblaRef] = useEmblaCarousel({ loop: true, duration: 100 }, [Autoplay()]);

    const kebabRef = useRef(null);
    const kebabButtonRef = useRef(null);

    useOutsideClickForTwoRef(kebabRef, kebabButtonRef, () => {
        dispatch(closeProductKebabMenu());
    });

    const kebabProductId = useSelector((state) => state.inventoryManagement.productKebab.productId);
    const { products } = useSelector((state) => state.inventoryManagement.products);

    const { selectedProducts, setSelectedProducts } = useContext(InventoryManagementContext);

    const [productSKUCode, setProductSKUCode] = useState('');

    const handleToggleClick = async () => {
        setLoading(true);
        let visibilityValue;

        if(product?.product?.isVisible) {
            visibilityValue = false;
        }
        else {
            visibilityValue = true;
        }

        try {
            let callData = {
                isVisible: visibilityValue
            }

            if(!visibilityValue) {
                callData.status = 'Inactive';
            }
            else {
                if(status !== 'Draft' && product?.product?.productStock == 0) {
                    callData.status = 'Out Of Stock';
                }
                else {
                    callData.status = 'Active';
                }
            }

            const response = await updateProduct(callData, product.product.id);

            if (response?.status === 200) {
                await cachedDataPublish([`/v1/product/${product?.product?.id}`]);
                const productVisibility = await accessProductVisibility(product?.product?.id);

                const newProductsArray = products.map(item =>
                    item.product.id === product.product.id
                        ? {
                            ...item,
                            product: {
                                ...item.product,
                                isVisible: productVisibility.isVisible,
                                status: productVisibility.isActive,
                            },
                        }
                        : item
                );

                dispatch(updateInventoryProducts(newProductsArray));
                setLoading(false);
            }
            else {
                setLoading(false);
                showToast('Unexpected error', 'error');
            }
        }
        catch(err) {
            setLoading(false);
            showToast('Unexpected error', 'error');
        }
    }

    useEffect(() => {
        if (Object.keys(product).length > 0) {
            if (!product?.product?.productSKU) {
                const foundVariant = product?.varients?.find(
                    (item) =>
                    item?.VarientSize === product?.product?.productSpecs?.size &&
                    item?.VarientColor === product?.product?.productSpecs?.color
                );

                if (foundVariant) {
                    setProductSKUCode(foundVariant.sku);
                }
            } else {
                setProductSKUCode(product?.product?.productSKU);
            }
        }
    }, [product]);

    const handleSelectBoxClick = () => {
        if(selectedProducts.includes(product.product.id)) {
            const filteredList = selectedProducts.filter(item => item !== product.product.id);
            setSelectedProducts(filteredList);
        }
        else {
            setSelectedProducts([ ...selectedProducts, product.product.id ]);
        }
    }

    const handleOpenKebab = () => {
        if(kebabProductId === product.product.id) {
            dispatch(closeProductKebabMenu());
        }
        else {
            dispatch(openProductKebabMenu(product.product.id));
        }
    }

    function AddProductSizeChart() {
        dispatch(setSelectedProduct(product));
        dispatch(setModal('select-size-chart'));
    }

    function handleProductClick() {
        if(status === 'Draft') {
            showToast('Cannot open Draft product. Please make the product Active.', 'warning');
            return;
        }
        else {
            navigate(`product/${product.product.id}`);
        }
    }

    return (
        <div className="flex items-center bg-[#FFFFFF] border-t text-[#121212] font-normal border-[#EAEAEA] select-none">
            <div className="flex items-center gap-2 w-[calc((35/100)*(100%-44px))] px-[10px] py-[6px]">
                <div onClick={handleSelectBoxClick} className={`cursor-pointer size-6 flex items-center justify-center rounded-md border ${isSelected ? 'border-none bg-primaryAccent' : 'border-[#D1D5DB]'} `} >
                    <img className='select-none' src={isSelected ? TickMark : undefined} alt="" />
                </div>

                <div onClick={handleProductClick} className="w-[calc(100%-32px)] flex items-center gap-2 cursor-pointer">
                    {
                        product?.product?.productImgUrls?.length > 0 ? (
                            <div className="size-16 flex items-center justify-center rounded-lg overflow-hidden">
                                <img
                                    className="size-full object-cover"
                                    src={product.product.productImgUrls[0]}
                                    alt=""
                                />
                            </div>
                        ) : (
                            <div className="size-16 rounded-lg bg-[#EAEAEA]"></div>
                        )
                    }

                    <h1
                        className={`font-semibold text-[14px] leading-6 w-[calc(100%-64px)] line-clamp-2 ${
                            status === "Draft" ? "text-[#666666]" : "text-[#121212]"
                        }`}
                    >
                        {product.product.productName}
                    </h1>
                </div>
            </div>

            <h2 className="w-[calc((14/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6 text-ellipsis whitespace-nowrap overflow-hidden">{productSKUCode || '-'}</h2>

            <h2 className="w-[calc((10/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6">₹{product?.product?.productSellingPrice}</h2>

            <div className="w-[calc((13/100)*(100%-44px))] px-[10px] py-[26px]">
                <h2 className={`${getStatusColor(status)} px-3 py-[2px] w-28 text-center font-medium text-[14px] leading-5 rounded-xl`}>{status}</h2>
            </div>

            <div className="w-[calc((15/100)*(100%-44px))] px-[10px] py-[26px]">
                {
                    product?.product?.SizeChartId ? 
                    <p className='text-base text-[#121212] font-semibold line-clamp-1'>{product?.product?.['SizeChart.chartName']}</p> : 
                    <>
                        {
                            (status === 'Active' || status === 'Out of Stock') ? 
                            <button onClick={AddProductSizeChart} className='font-semibold text-base text-link'>Add Size Chart</button> : 
                            <p className='font-semibold text-base text-[#666666]'>Add Size Chart</p>
                        }
                    </>
                }
            </div>

            <div className="w-[calc((13/100)*(100%-44px))] px-[10px] py-[26px] flex items-center justify-center">
                {
                    status !== 'Draft' && 
                    <button onClick={handleToggleClick} className={`outline-none flex items-center w-11 h-6 p-[2px] rounded-xl ${product?.product?.isVisible ? 'bg-[#4F46E5]' : 'bg-[#E5E7EB]'}`}>
                        <img className={`${product?.product?.isVisible ? 'ml-auto mr-[-2px]' : 'ml-[-2px]'} rounded-full`} src={showhide} alt="" />
                    </button>
                }
            </div>

            <div className="w-[44px] flex items-center justify-center">
                {
                    selectedProducts.length === 0 && 
                    <div onClick={handleOpenKebab} ref={kebabButtonRef} className='relative w-full py-[26px] flex items-center justify-center outline-none cursor-pointer'>
                        <img src={DotsVertical} alt="" />

                        {
                            kebabProductId === product.product.id && 
                            <KebabMenu 
                                boxRef={kebabRef} 
                                product={product} 
                            />
                        }
                    </div>
                }
            </div>

            {loading && <LoadingTransparent message="Updating product status..." />}
        </div>
    );
}

export default ProductBar;
